export const CONNECTED = 'CONNECTED'
export const MESSAGE = 'MESSAGE'
export const TOGGLE_OVERLAY = 'TOGGLE_OVERLAY'
export const TOGGLE_MESSAGE_OVERLAY = 'TOGGLE_MESSAGE_OVERLAY'
export const TOGGLE_EDIT_MESSAGE_OVERLAY = 'TOGGLE_EDIT_MESSAGE_OVERLAY'
export const ON_CHANGE = 'ON_CHANGE'
export const ON_EDIT = 'ON_EDIT'
export const ON_SUBMIT = 'ON_SUBMIT'
export const LOADING = 'LOADING'
export const EXPIRATION_DATE = 'EXPIRATION_DATE'
export const MARK_AS_WELCOME = 'MARK_AS_WELCOME'
export const SET_CURRENT_EDITING_ITEM = 'SET_CURRENT_EDITING_ITEM'
export const ON_CHANGE_MESSAGE = 'ON_CHANGE_MESSAGE'
export const SET_FILE_SCOPE = 'SET_FILE_SCOPE'
export const SET_CURRENT_TAB = 'SET_CURRENT_TAB'
export const SET_SELECTED_ORG_GROUPS = 'SET_SELECTED_ORG_GROUPS'
export const SET_CURRENT_SELECTED_ITEMS = 'SET_CURRENT_SELECTED_ITEMS'
export const SET_CURRENT_ITEMS = 'SET_CURRENT_ITEMS'
export const SET_CURRENT_TOGGLE_ITEM_FUNCTION =
	'SET_CURRENT_TOGGLE_ITEM_FUNCTION'
export const SET_CURRENT_HIDE_SELECTED_ITEMS_FUNCTION =
	'SET_CURRENT_HIDE_SELECTED_ITEMS_FUNCTION'
export const SET_CURRENT_SHOW_SELECTED_ITEMS_FUNCTION =
	'SET_CURRENT_SHOW_SELECTED_ITEMS_FUNCTION'
export const SET_CURRENT_SHOW_SELECTED_ITEMS = 'SET_CURRENT_SHOW_SELECTED_ITEMS'
export const SET_SELECTED_USERS = 'SET_SELECTED_USERS'
export const SET_SELECTED_LOCATION_GROUPS = 'SET_SELECTED_LOCATION_GROUPS'
export const SET_SELECTED_LOCATIONS = 'SET_SELECTED_LOCATIONS'
export const SET_SELECTED_ROLES = 'SET_SELECTED_ROLES'
export const SET_SELECTED_STORES = 'SET_SELECTED_STORES'
export const RESET_SELECTED_ITEMS = 'RESET_SELECTED_ITEMS'
export const SET_ASSIGN_SEARCH_VALUE = 'SET_ASSIGN_SEARCH_VALUE'
export const SET_SHOW_SELECTED_ORG_GROUPS = 'SET_SHOW_SELECTED_ORG_GROUPS'
export const SET_SHOW_SELECTED_USERS = 'SET_SHOW_SELECTED_USERS'
export const SET_SHOW_SELECTED_LOCATION_GROUPS =
	'SET_SHOW_SELECTED_LOCATION_GROUPS'
export const SET_SHOW_SELECTED_LOCATIONS = 'SET_SHOW_SELECTED_LOCATIONS'
export const SET_SHOW_SELECTED_STORES = 'SET_SHOW_SELECTED_STORES'
export const SET_SHOW_SELECTED_ROLES = 'SET_SHOW_SELECTED_ROLES'
export const IS_REQ_LOADING = 'IS_REQ_LOADING'
export const TOGGLE_MODAL = 'TOGGLE_MODAL'
export const LOADED = 'LOADED'
